import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useCompanyStore } from '@/stores/company';

export const redirectToProfileIfNotAdmin: NavigationGuard = (to, from, next) => {
  if (useAuthStore().isUserAdmin) {
    return next();
  } else {
    next({ name: 'settings-account-profile' });
  }
};

export const redirectToProfileIfNotAdminOrTeamlead: NavigationGuard = (to, from, next) => {
  if (useAuthStore().isUserAdmin || useAuthStore().isUserTeamlead) {
    return next();
  } else {
    next({ name: 'settings-account-profile' });
  }
};

export const redirectToProfileIfNotOffersV1AndNotAdmin: NavigationGuard = (to, from, next) => {
  if (useCompanyStore().isUsingOffersV1 && (useAuthStore().isUserAdmin || useAuthStore().isUserOffersEditor)) {
    return next();
  } else {
    next({ name: 'settings-account-profile' });
  }
};
